<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Distribuidor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <distributor-form :server-errors="serverErrors" @save="saveDistributor"> </distributor-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import DistributorForm from './Forms/DistributorForm';
import swal from 'sweetalert2';

export default {
  name: 'DistributorsCreate',
  components: {
    RouteBreadCrumb,
    DistributorForm,
  },

  data() {
    return {
      serverErrors: [],
    };
  },

  methods: {
    saveDistributor(distributor) {
      this.serverErrors = [];
      this.$services
        .resource('distributors')
        .create(distributor)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El distribuidor fue creado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'DistributorsList' }));
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },
  },
};
</script>
